import { IbgeCityDto } from 'src/dto/ibge.dto'
import { IbgeService } from 'src/services/api/ibge.service'

export class IbgeController {
  private service: IbgeService

  constructor() {
    this.service = new IbgeService()
  }

  public async getCitiesByUf(uf: string): Promise<IbgeCityDto[]> {
    const response = await this.service.getCitiesByUf(uf)
    return response.data
  }
}
